export default {
  PostComment: 'Comentarios',
  MentionComment: 'Comentarios en menciones',
  ExternalComment: 'Comentarios externos',
  ReviewComment: 'Comentarios en evaluaciones',
  VisitorComment: 'Comentario en publicación de visitante',
  Mention: 'Menciones',
  Review: 'Evaluaciones',
  Post: 'Publicaciones propietarias',
  VisitorPost: 'Publicaciones de visitante',
  Inbox: 'Inbox',
  Story: 'Story',
  Reels: 'Reels',
};
